import React from 'react';
import Title from '../../components/Typography/Title';

import * as S from './style';

const animation = require('../../animations/animation.json');

interface ArticleNotFoundProps {
    title: string;
}

const ArticleNotFound: React.FC<ArticleNotFoundProps> = ({ title }) => {
    return (
        <S.StyledNotFound>
            <Title title={title} />
        </S.StyledNotFound>
    )
}

export default ArticleNotFound;